import { AppRestClient } from "@/util/rest/clients/app-rest-client";

import { BizLocationModels } from "./bizLocation.models";

export namespace BizLocationApi {
  export const list = (
    limit: number,
    filter?: BizLocationModels.BizLocationPaginationFilterDto,
    page?: number,
    cursor?: string,
  ) => {
    return AppRestClient.get(
      { resSchema: BizLocationModels.BizLocationPaginationResponseDtoSchema },
      `/biz/location/list`,
      {
        params: {
          filter,
          limit,
          page,
          cursor,
        },
      },
    );
  };
}
